<template>
  <div id="lineStartupCompleteList" class="common_type2">
    <div class="common_tit_wrap">
      <div class="common_page_tit">회선관리: 정지해제</div>
      <div class="common_page_desc">
        저압 모뎀 웹사이트
        <template v-if="userInfoDetail.userRole === 2 || userInfoDetail.userRole === 3">
          |
          <template v-if="userInfoDetail.affiliateCode != null">
            <template v-for="afc in afcList" v-if="afc.codeValue === userInfoDetail.affiliateCode">{{afc.codeName}}</template>
          </template>
          <template v-if="userInfoDetail.officeCode != null">
            <template v-for="ofc1 in ofc1List" v-if="ofc1.codeValue === userInfoDetail.officeCode.substring(0, 5)">{{ofc1.codeName}}</template>
          </template>
        </template>
      </div>
      <div class="common_progress_wrap">
        <div class="common_progress_start" @click="movePage('RequestList')">요청<span style="display: none;">({{countParams.cancel['1']}}건)</span></div>
        <div class="common_progress_middle" @click="movePage('ProgressList')">처리중<span style="display: none;">({{countParams.cancel['2']}}건)</span></div>
        <div class="common_progress_end on">완료<span style="display: none;">({{countParams.cancel['3']}}건)</span></div>
      </div>
    </div>
    <div class="common_list_notice_wrap">
      <img class="common_list_notice_bg" src="../../assets/common/ic_warning.svg"/>
      <div class="common_list_notice_tit_wrap">
        <div class="common_list_notice_tit">안내</div>
        <div class="common_list_notice_desc">회선관리: 정지해제 메뉴 기능을 처음 이용하시는 분은 반드시 우측의 [매뉴얼 & 담당자]를 확인하시고 이용하여 주시기 바랍니다.</div>
      </div>
      <div class="common_list_notice_manual" @click="openManual('LineStartupComplete')">매뉴얼 & 담당자</div>
    </div>
    <div class="common_list_wrap">
      <div class="common_list_top">
        <div class="common_list_top_select">
          <select v-model="selectSize" @change="search(1)">
<!--            <option value="10">10줄 표시</option>-->
<!--            <option value="20">20줄 표시</option>-->
            <option value="50">50줄 표시</option>
            <option value="100">100줄 표시</option>
            <option value="200">200줄 표시</option>
            <option value="500">500줄 표시</option>
          </select>
        </div>
        <template v-if="mySession.userRole === 2">
          <div class="btn_top btn_green_t" @click="toggleList">모뎀 요청보기({{isOffice ? '등록자' : '본부'}})</div>
        </template>
        <div class="datepicker_wrap" style="margin-left: auto;">
          <vue-datepicker-local
            v-model="searchParams.dateRange"
            inputClass="vdl_input"
            :local="ko"/>
        </div>
        <div class="btn_top btn_blue" @click="search(1)">검색</div>
      </div>
      <div class="common_list_middle">
        <div class="common_list_head">
          <div><span><input type="checkbox" v-model="checkAll" @click.stop="onClickCheckAll"/></span></div>
          <div><span>본부</span></div>
          <div><span>요청일</span></div>
          <div><span>완료일</span></div>
          <div><span>처리현황</span></div>
          <div><span>요청자</span></div>
          <div><span>처리담당자</span></div>
          <div><span>모뎀정보(엑셀)</span></div>
          <div><span>모뎀갯수</span></div>
          <div><span>정지해제</span></div>
        </div>
        <div class="common_list_body">
          <div class="common_list_no_data" v-if="list.length <= 0">
            <img src="../../assets/common/bg_list_no_data.png"/>
            <span>대상 모뎀이 없습니다.</span>
          </div>
          <div :key="'csGroup_' + item.csGroupPid" v-for="item in list">
            <div><span><input type="checkbox" v-model="item.check" :value="item.csGroupPid" @click.stop="onClickCheckItem(item)"/></span></div>
            <div>
              <span v-if="item.officeCode != null">
                <template v-for="ofc1 in ofc1List" v-if="ofc1.codeValue === (item.officeCode.length === 5 ? item.officeCode : item.officeCode.substring(0, 5))">{{ofc1.codeName}}</template>
              </span>
              <span v-else>-</span>
            </div>
            <div>
              <span v-if="item.regDate != null">{{item.regDate}}</span>
              <span v-else>-</span>
            </div>
            <div>
              <span v-if="item.updDate != null">{{item.updDate}}</span>
              <span v-else>-</span>
            </div>
            <div>
              <span v-if="item.progressType != null">
                <template v-for="prg in prgList" v-if="prg.codeValue === item.progressType">{{prg.codeName}}</template>
              </span>
              <span v-else>-</span>
            </div>
            <div><span class="link fc_primary_blue" @click="showPopup(`회선 정지해제 요청자 정보`, 'MemberPopup', item, 'R')">{{item.userName}}</span></div>
            <div><span class="link fc_primary_blue" @click="showPopup(`회선 정지해제 처리담당자 정보`, 'MemberPopup', item, 'P')">{{item.procUserName}}</span></div>
            <div><span class="btn_status fc_white bc_status_gray" @click="downloadExcel(item)">다운로드</span></div>
            <div><span :class="{'link fc_primary_blue' : item.failedCount}" @click="showFailedPopup(item)">{{item.successCount}}/{{item.modemCount}}ea</span></div>
            <div><span>처리완료</span></div>
          </div>
        </div>
      </div>
      <div class="common_bottom_wrap">
        <div class="common_list_page_wrap center_page">
          <paginate
            v-model="pageParams.page"
            :pageCount="pageParams.totalPage"
            :clickHandler="search"
            :prevText="'<'"
            :nextText="'>'"
            :containerClass="'page_wrap'">
          </paginate>
        </div>
      </div>
    </div>
    <excel-exporter ref="excel" :filter="excelFilter" :type="'modemCancel'" @downloading="excelDownloadStarted" @fail="excelDownloadFail"/>
    <modal name="viewPopup" classes="popup_modal" width="725px" height="auto" scrollable>
      <popup :popup-params="popupParams" @hidePopup="hidePopup"/>
    </modal>
    <modal name="loadingProgress" classes="loading_progress_wrap" width="300px" height="200px">
      <div>{{progressMsg}}</div>
    </modal>
  </div>
</template>

<script>
import VueDatepickerLocal from 'vue-datepicker-local'
import Popup from '../common/Popup.vue'
import ExcelExporter from '../excel/ExcelExporter.vue'
import common from '../../script/common'
import modemStop from '../../script/modemStop'
import {defaultLoadingOptions} from '../../script/defaultConfig'

export default {
  components: {VueDatepickerLocal, ExcelExporter, Popup},
  props: ['countParams'],
  data () {
    return {
      // Common
      mySession: {},
      ko: common.getDatepickerLocal(),
      userInfoDetail: JSON.parse(sessionStorage.getItem('userInfoDetail')),
      // Data
      afcList: [],
      ofcList: [],
      ofc1List: [],
      rwkList: [],
      prtList: [],
      sttList: [],
      prgList: [],
      crsList: [],
      canRequestFlagList: common.canRequestFlagList(),
      // Search
      isOffice: false,
      searchParams: {
        dateRange: []
      },
      // List
      filter: {
        page: 1,
        size: parseInt(this.selectSize)
      },
      selectSize: '50',
      list: [],
      checkAll: false,
      selectedItemList: [],
      // Paging
      pageParams: {
        hasNext: false,
        totalElements: 0,
        totalPage: 1,
        page: 10,
        size: parseInt(this.selectSize)
      },
      // Popup
      popupParams: {
        title: '',
        component: '',
        data: {}
      },
      // Excel Download
      excelFilter: {
        page: 1,
        size: 100000,
        isStop: false
      },
      excelDownloading: false,
      // loading
      progressMsg: '',
      vueLoadingOverlay: null
    }
  },
  mounted () {
    common.getSession(response => {
      if (response.data.resultCode === 1 && response.data.result != null && response.data.result.userPid != null && response.data.result.userRole != null) {
        this.mySession = response.data.result
        this.$emit('getCount')
        let intervalCnt = 0
        let interval = setInterval(() => {
          if (common.checkValidateData('session', sessionStorage.getItem('afcList')) &&
            common.checkValidateData('session', sessionStorage.getItem('ofcList')) &&
            common.checkValidateData('session', sessionStorage.getItem('rwkList')) &&
            common.checkValidateData('session', sessionStorage.getItem('prtList')) &&
            common.checkValidateData('session', sessionStorage.getItem('sttList')) &&
            common.checkValidateData('session', sessionStorage.getItem('prgList')) &&
            common.checkValidateData('session', sessionStorage.getItem('crsList'))) {
            clearInterval(interval)
            this.afcList = JSON.parse(sessionStorage.getItem('afcList'))
            this.ofcList = JSON.parse(sessionStorage.getItem('ofcList'))
            this.ofc1List = this.getOfc1List()
            this.rwkList = JSON.parse(sessionStorage.getItem('rwkList'))
            this.prtList = JSON.parse(sessionStorage.getItem('prtList'))
            this.sttList = JSON.parse(sessionStorage.getItem('sttList'))
            this.prgList = JSON.parse(sessionStorage.getItem('prgList'))
            this.crsList = JSON.parse(sessionStorage.getItem('crsList'))
            if (this.$route.params != null && this.$route.params.searchParams != null) {
              this.searchParams = this.$route.params.searchParams
              this.search(1)
            } else {
              this.search(1)
            }
          } else if (intervalCnt > 10) {
            clearInterval(interval)
            common.amsAlert('retry', '필수 데이터를 불러오지 못했습니다.')
          } else {
            intervalCnt++
          }
        }, 200)
      } else {
        common.amsAlert('general', '로그아웃 되었습니다.\n다시 로그인해주세요.')
        this.$router.replace('/Login')
      }
    })
  },
  methods: {
    // Button Action
    movePage (path) {
      this.$router.push(path)
    },
    downloadExcel (item) {
      this.excelFilter.groupPid = item.csGroupPid
      if (this.excelDownloading) {
        common.amsAlert('general', '이미 다운로드 처리중입니다.')
        return
      }
      if (confirm('엑셀 다운로드는 데이터 양에 따라 상당한 시간이 소요될 수 있으며 데이터 10만개당 하나의 파일로 다운로드 됩니다.\n또한 브라우저 보안정책에 따라 연속 다운로드 권한을 허용해야합니다.\n정말 다운로드 하시겠습니까?')) {
        this.progressMsg = '다운로드 준비중...'
        this.$modal.show('loadingProgress')
        this.vueLoadingOverlay = this.$loading.show(defaultLoadingOptions)
        this.$refs.excel.runExport()
        this.excelDownloading = true
      }
    },
    excelDownloadStarted () {
      this.$modal.hide('loadingProgress')
      this.vueLoadingOverlay.hide()
      this.excelDownloading = false
    },
    excelDownloadFail () {
      this.$modal.hide('loadingProgress')
      this.vueLoadingOverlay.hide()
      this.excelDownloading = false
    },
    // Common
    getOfc1List () {
      return this.ofcList.filter(item => { return item.codeLevel === 0 })
    },
    // List
    onClickCheckAll () {
      this.selectedItemList = []
      for (let i = 0; i < this.list.length; i++) {
        this.list[i].check = !this.checkAll
        if (!this.checkAll) {
          this.selectedItemList.push(this.list[i])
        }
      }
    },
    onClickCheckItem (selectedItem) {
      if (selectedItem.check) {
        this.selectedItemList = this.selectedItemList.filter(item => { return item.csGroupPid !== selectedItem.csGroupPid })
      } else {
        this.selectedItemList.push(selectedItem)
      }
      this.checkAll = this.selectedItemList.length === this.list.length
    },
    toggleList () {
      this.isOffice = !this.isOffice
      this.search(1)
    },
    search (page) {
      this.filter = {
        page: page,
        size: parseInt(this.selectSize),
        isStop: false,
        step: 3
      }
      if (this.mySession.userRole === 2) {
        delete this.filter['sameOffice']
        if (this.isOffice) {
          this.filter.sameOffice = true
        }
      } else if (this.mySession.userRole === 3 || this.mySession.userRole === 4) {
        this.filter.sameOffice = true
      }
      delete this.filter['updDateStart']
      delete this.filter['updDateEnd']
      if (this.searchParams.dateRange != null && this.searchParams.dateRange.length === 2) {
        this.filter.updDateStart = this.searchParams.dateRange[0]
        this.filter.updDateEnd = this.searchParams.dateRange[1]
      }
      this.updateList()
    },
    updateList () {
      let vueLoadingOverlay = this.$loading.show(defaultLoadingOptions)
      modemStop.getModemStop(this.filter, response => {
        console.log('[회선관리: 정지해제] 완료 목록', response)
        vueLoadingOverlay.hide()
        if (response.data.resultCode === 1) {
          const data = response.data.result.body
          let list = data.list
          for (let i = 0; i < list.length; i++) {
            list[i].check = false
          }
          this.list = list
          this.pageParams = {
            hasNext: data.hasNext,
            totalElements: data.totalElements,
            totalPage: data.totalPage,
            page: this.filter.page,
            size: this.filter.size
          }
        } else {
          common.amsAlert('retry', '모뎀 목록을 불러오지 못했습니다.')
          this.list = []
          this.pageParams = {
            hasNext: false,
            totalElements: 0,
            totalPage: 1,
            page: 1,
            size: this.filter.size
          }
        }
        this.checkAll = false
        this.selectedItemList = []
      })
    },
    showPopup (title, component, data, type) {
      this.popupParams.title = title
      this.popupParams.component = component
      this.popupParams.data = { type: 'C', data: data, userType: type, from: 'CANCEL' }
      this.$modal.show('viewPopup')
    },
    showFailedPopup (data) {
      if (!data.failedCount || data.failedCount <= 0) {
        return
      }
      data.from = 'CANCEL'
      this.popupParams.title = '실패 사유'
      this.popupParams.component = 'FailedDescPopup'
      this.popupParams.data = { data: data }
      this.$modal.show('viewPopup')
    },
    hidePopup (args) {
      this.$modal.hide('viewPopup')
      if (args != null && args.type != null) {
        if (args.type === 'L') {
          this.selectedItemList = []
          this.updateList()
        }
      }
    },
    openManual (type) {
      common.openManualNewWindow(type)
    }
  }
}
</script>

<style scoped>
#lineStartupCompleteList .common_list_middle > .common_list_head > div,
#lineStartupCompleteList .common_list_middle > .common_list_body > div > div {
  flex-shrink: 1;
  width: 100%;
}

#lineStartupCompleteList .common_list_middle > .common_list_head > div:nth-child(1),
#lineStartupCompleteList .common_list_middle > .common_list_body > div > div:nth-child(1) {
  flex-shrink: 0;
  width: 13px;
}

#lineStartupCompleteList .common_list_middle > .common_list_head > div:nth-child(3),
#lineStartupCompleteList .common_list_middle > .common_list_body > div > div:nth-child(3),
#lineStartupCompleteList .common_list_middle > .common_list_head > div:nth-child(4),
#lineStartupCompleteList .common_list_middle > .common_list_body > div > div:nth-child(4) {
  flex-shrink: 0;
  width: 65px;
}
</style>



// WEBPACK FOOTER //
// src/components/lineStartup/LineStartupCompleteList.vue